export const DOMESTIC = "domestic";
export const INTERNATIONAL = "international";